import { GET_CHANGE_MOBILE_CARD_PROFILE_REQUEST, GET_EXISTING_MOBILE_REQUEST } from "@/actions/changemobileno/actionTypes";
import { put, takeLatest, call } from "redux-saga/effects";
import * as actions from '@/actions';
import * as apis from '@/apis/changemobileno';
import { IFetchExistingServiceNumber, IGetChangeMobileCardProfile } from "@/actions/changemobileno/models/types";

function* getChangeMobileCardProfile({ reqData, callback }: IGetChangeMobileCardProfile) {
  try {
    const result = yield call(apis.getChangeMobileCardProfileDetails, reqData);
    yield put(actions.getChangeMobileNoCardProfile.success(result.data));
    yield put(actions.resetCardProfile());
    if (result.data?.simType) {
      callback(result.data);
    } else {
      const error = { response: { data: { message: 'SimType Not available' } } }
      yield put(actions.getChangeMobileNoCardProfile.failure(error));
    }
  } catch (error) {
    yield put(actions.getChangeMobileNoCardProfile.failure(error));
  }
}

function* fetchExistingServiceNumber({ reqData }: IFetchExistingServiceNumber) {
  try {
    const result = yield call(apis.getChangeExistingServiceNumber, reqData);
    yield put(actions.getExistingMobileNumber.success(result.data));
  } catch (error) {
    yield put(actions.getExistingMobileNumber.failure(error));
  }
}

export default function* changeMobileNoSagas() {
  yield takeLatest(GET_CHANGE_MOBILE_CARD_PROFILE_REQUEST, getChangeMobileCardProfile);
  yield takeLatest(GET_EXISTING_MOBILE_REQUEST, fetchExistingServiceNumber);
}
